export const FETCH_LEAVE_PRIOR_LIST_REQUEST = "FETCH_LEAVE_PRIOR_LIST_REQUEST";
export const FETCH_LEAVE_PRIOR_LIST_SUCCESS = "FETCH_LEAVE_PRIOR_LIST_SUCCESS";
export const FETCH_LEAVE_PRIOR_LIST_FAILURE = "FETCH_LEAVE_PRIOR_LIST_FAILURE";

export const FETCH_NOT_APPROVED_LEAVE_PRIOR_REQUEST = "FETCH_NOT_APPROVED_LEAVE_PRIOR_REQUEST";
export const FETCH_NOT_APPROVED_LEAVE_PRIOR_SUCCESS = "FETCH_NOT_APPROVED_LEAVE_PRIOR_SUCCESS";
export const FETCH_NOT_APPROVED_LEAVE_PRIOR_FAILURE = "FETCH_NOT_APPROVED_LEAVE_PRIOR_FAILURE";

export const UPDATE_LEAVE_PRIOR_REQUEST = "UPDATE_LEAVE_PRIOR_REQUEST";
export const UPDATE_LEAVE_PRIOR_SUCCESS = "UPDATE_LEAVE_PRIOR_SUCCESS";
export const UPDATE_LEAVE_PRIOR_FAILURE = "UPDATE_LEAVE_PRIOR_FAILURE";